export interface RegenerateTokenDto
{
    getRefreshToken(): string;

    getAccessToken(): string;
    getExpiry(): number;

}

export class RegenerateTokenDtoImpl implements RegenerateTokenDto
{
    private refreshToken: string;
    private accessToken: string;
    private expiry: number;

    getRefreshToken(): string 
    {
        return this.refreshToken;
    }
    setRefreshToken(refreshToken: string)
    {
        this.refreshToken = refreshToken;
    }

    getAccessToken(): string 
    {
        return this.accessToken;
    }
    setAccessToken(accessToken: string)
    {
        this.accessToken = accessToken;
    }

    getExpiry(): number 
    {
        return this.expiry;
    }
    setExpiry(expiry: number)
    {
        this.expiry = expiry;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/regeneratetoken/regeneratetokendto.tsx